
@if (!(paymentsLoading$ | async)) {
  <div class="grid-container full-height full v-pad">
    <h2 aria-controls="payment-region" id="payment-region-header"><button class="button large expanded" [ngClass]="{'down' : !paymentVisible}" (click)="paymentAccordionClick()">Payments - {{organization}}</button></h2>
    <div class="form-width" id="payment-region" aria-labelledby="payment-region-header" role="region" aria-expanded="{paymentVisible}" [ngClass]="{'hide-below-large-bp': !paymentVisible}">
      <div class="payment-add">
        <div class="grid-x">
          <div class="cell large-12">
            <h2>Outstanding payments for {{organization}}</h2>
          </div>
        </div>
        <div class="grid-x display-block">
          <div class="cell large-12 bold">
            <svg-icon icon="icon-alert" class="tiny"></svg-icon>&nbsp;&nbsp;Leaving this page without issuing receipts will remove all payments applied.<br />
          </div>
        </div>
        <div class="add-payment-entry margin-bottom">
          <div class="grid-x grid-margin-xclear-buttons">
            <div class="cell large-5 bold pay-title">
              Add Payment Received
            </div>
            <div class="cell large-4 text-right bold">
              Wallet Balance: {{availableFunds | currency: 'USD':'symbol':'1.2-2' }}
            </div>
            <div class="cell large-3 text-right">
              <button class="button no-margin-bottom margin-right" #payButton (click)="confirmPayAll()" [disabled]="disablePayAll">Pay All Organization Fees</button>
            </div>
          </div>
          <div class="grid-x grid-margin-x minor-margin-top clear-buttons">
            <div class="cell large-3">
              <label for="receivedOn" class="required">Payment Received:</label>
              <common-date-picker #receivedOn [id]="'receivedOn'" (dateUpdated)="receivedDateChanged($event)" [futureDateLimit]="now" [alignRight]="false"></common-date-picker>
            </div>
            <div class="cell large-2">
              <label for="paymentType" class="required">Type:</label>
              <select class="no-margin-bottom" id="paymentType" [(ngModel)]="selectedType" [disabled]="havePayment">
                @for (type of paymentTypes; track type) {
                  <option [ngValue]="type">{{type.display}}</option>
                }
              </select>
            </div>
            <div class="cell large-2">
              <label for="paymentAmount" class="required">Amount:</label>
              <input class="no-margin-bottom" id="paymentAmount" min="0.01" step="0.01" type="number" [(ngModel)]="paymentAmount" [disabled]="havePayment" />
            </div>
            @if (selectedType.id === 'LocalCheck' || selectedType.id === 'MoneyOrder') {
              <div class="cell large-auto">
                <label for="checkMONumber" [ngClass]="{ 'required' : selectedType.id === 'LocalCheck' || selectedType.id === 'MoneyOrder'  }">Chk/MO #:</label>
                <input class="no-margin-bottom" type="text" id="checkMONumber" [(ngModel)]="itemNumber" />
              </div>
            }
            <div class="cell large-shrink text-right">
              <br />
              <button class="button no-margin-bottom" (click)="acceptPayment($event)" [disabled]="disableAdd">Add Payment</button>
            </div>
          </div>
          <div class="line-height-125-rem text-center minor-margin-top">
            @if (havePayment) {
              Note: Only one fund source can be used at a time, apply full balance to add another fund type.
            }
            &nbsp;
          </div>
          <div class="grid-x grid-margin-x">
            <div class="cell large-6">
              <span class="bold">Available Funds</span><br />
              @if (!havePayment) {
                No funds currently available to be applied.
              }
              <payment-display-item [cashItems]="undisbursedCashPayments" [nonCashItems]="undisbursedNoncashPayments" [isUsed]="false"></payment-display-item>
            </div>
            <div class="cell large-6">
              <span class="bold">Applied Funds</span><br />
              <payment-display-item [cashItems]="disbursedCashPayments" [nonCashItems]="disbursedNoncashPayments" [isUsed]="true"></payment-display-item>
            </div>
          </div>
        </div>
      </div>
      <div class="payment-section">
        <div class="application-list">
          @for (application of applicationList; track application) {
            <div class="application">
              <div class="grid-x margin-bottom">
                <div class="cell small-12 medium-auto bold">
                  Application #: <span class="medium-blue">{{application}} - {{ getApplicationTypeForApplication(application) }}</span>
                </div>
                <div class="cell small-12 medium-shrink bold">
                  Application Date: <span class="medium-blue">{{getApplicationDateForApplication(application)}}</span>
                </div>
              </div>
              <div class="grid-x application-headers">
                <div class="cell large-2 input-group-line-height">
                  Payment Number
                </div>
                <div class="cell large-4 input-group-line-height">
                  Payment Type
                </div>
                <div class="cell large-1 input-group-line-height">
                  Fee
                </div>
                <div class="cell large-1 input-group-line-height">
                  Paid
                </div>
                <div class="cell large-2 input-group-line-height">
                  Status
                </div>
                <div class="cell large-2 input-group-line-height">
                  Make Payment
                </div>
              </div>
              @for (payment of getPaymentsByApplication(application); track payment) {
                <div class="grid-x fee-row">
                  <div class="small-6 medium-header">Payment Number</div>
                  <div class="cell small-6 large-2 input-group-line-height">
                    <span [ngClass]="{'paid':payment.paymentStatus==='Paid', 'pending':payment.paymentStatus==='Pending', 'pendingReceipt':payment.paymentStatus==='Pending Receipt', 'partial':payment.paymentStatus==='Partial'}" class="minor-margin-right"></span>{{payment.id}}
                  </div>
                  <div class="small-6 medium-header">Payment Type</div>
                  <div class="cell small-6 large-4 padding-right input-group-line-height">
                    {{getDescription(payment)}}
                  </div>
                  <div class="small-6 medium-header">Fee</div>
                  <div class="cell small-6 large-1 input-group-line-height">
                    {{payment.fee | currency: 'USD': 'symbol' :'1.2-2'}}
                  </div>
                  <div class="small-6 medium-header">Paid</div>
                  <div class="cell small-6 large-1 input-group-line-height">
                    {{payment.amountPaid | currency: 'USD':'symbol' :'1.2-2'}}
                  </div>
                  <div class="small-6 medium-header">Status</div>
                  <div class="cell small-6 large-2 input-group-line-height">
                    {{payment.paymentStatus}}
                  </div>
                  <div class="small-6 medium-header">Make Payment</div>
                  <div class="cell small-6 large-2">
                    <div class="input-group">
                      <span class="input-group-label invalid-payment bold" [ngClass]="{ 'hide' : alertInvalid(payment)}"
                      title="Invalid Amount, either you've provided a number that is not a positive 2 digit precision number greater than zero, or you have insufficient funds to cover said amount.">!</span>
                      <input class="input-group-field" type="number" min="0.01" step="0.01" (blur)="setPrecision(payment)" [(ngModel)]="payment.unappliedFunds">
                      <div class="input-group-button">
                        <button class="button" (click)="pay(payment)" [disabled]="disablePay(payment)">Pay</button>
                      </div>
                    </div>
                  </div>
                </div>
              }
              <div class="grid-x margin-top">
                <div class="cell large-12 text-align-right">
                  <span class="margin-right">Total Due: <b>{{getTotalDueForApplication(application) | currency:'USD':'symbol':'1.2-2'}}</b></span>
                  <button class="button no-margin-bottom" (click)="confirmPayAllForApplication(application)" [disabled]="disablePayForApplication(application)">Pay All Application Fees</button>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
    <h2 aria-controls="receipt-region" id="receipt-region-header"><button class="button large expanded" [ngClass]="{'down' : !receiptVisible}" (click)="receiptAccordionClick()">Receipts - {{organization}}</button></h2>
    <div class="receipt-section-container" id="receipt-region" aria-labelledby="receipt-region-header" role="region" attr.aria-expanded="{{receiptVisible}}" [ngClass]="{'hide-below-large-bp': !receiptVisible}">
      <div class="receipt-section">
        <div class="receipt-header">
          <div class="grid-x">
            <div class="cell small-12 text-right">
              <h3 class="receipt-h3">Receipts</h3>
            </div>
            <div class="small-12 bold">
              <svg-icon icon="icon-alert" class="tiny"></svg-icon>&nbsp;&nbsp;Any users actively accessing the application could cause the payment received date to not become correctly referenced in the application.  Please ensure that no users are actively accessing the application when applying its payments.
            </div>
          </div>
          @if (paymentsApplied) {
            <div class="grid-x ">
              <div class="cell small-12 red line-height-125-rem">
                Funds applied to payments are not marked paid until a receipt is issued.
              </div>
              @if (hasPartials) {
                <div class="cell small-12 red italic line-height-125-rem padding-top">
                  No receipts can be issued while any received checks or money orders have only part of their funds applied to outstanding payments.
                </div>
              }
            </div>
          }
          <div class="receipt-tab padding-left padding-right">
            @for (application of applicationList; track application) {
              <div>
                <receipt [applicationNumber]="application"
                  [autoGeneratePdf]="false"
                  [isPaid]="true"
                  [shrinkFont]="true"
                  [hasPartials]="hasPartials"
                  [isCredit]="false"
                  [records]="getPaymentsByApplication(application)"
                  [unpaidRecordStatuses]="unpaidStatuses"
                  [isSinglePaymentType]="false"
                  (receiptIssued)="onReceiptIssued($event)">
                </receipt>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
} @else {
  Loading data...
}

